/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamLangListItemViewModel } from "../types/ExamLangListItemViewModel.ts";

export const examLangListItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do idioma de prova.")),
  cultureInfo: z
    .string()
    .describe("Código de cultura do idioma (ex: pt-BR, en-US).")
    .nullish(),
  cultureInfoDisplay: z
    .string()
    .describe("Nome de exibição do idioma para o usuário.")
    .nullish(),
  active: z.optional(
    z.boolean().describe("Indica se o idioma de prova está ativo."),
  ),
}) as unknown as ToZod<ExamLangListItemViewModel>;
